import { analysis } from './analysis';

export const scenario = {
    id: 'scenario_id',
    name: 'Login and display list results',
    score: analysis.score,
    status: 'finished',
    precision: 1.2,
    milestones: [
        { title: 'Get list results', time: 2000 },
        { title: 'Create a new result', time: 5000 },
    ],
};
